


















































































































import Session from '@/components/Session.vue';
import ElCard from '@/overrides/ElCard.vue';
export default {
	name: 'login',
	inject: ['responsive'],
	components: {
		Session,
		ElCard,
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value.length < 6) callback(new Error('Mínimo 6 caracteres'));
			else if (this.ruleForm.checkPass !== '') this.$refs.formPass.validateField('checkPass');
			callback();
		};
		var validatePass2 = (rule, value, callback) => {
			if (value !== this.ruleForm.pass) callback(new Error('Las contraseñas no coinciden'));
			else callback();
		};
		return {
			showSession: false,
			loading: false,
			loadingi: false,
			publicPath: process.env.BASE_URL,
			form: {
				mail: '',
			},
			ruleForm: {
				hash: '',
				pass: '',
				checkPass: '',
			},
			rules: {
				pass: [{ validator: validatePass, trigger: 'blur' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }],
				hash: this.$route.params.hash,
			},
		};
	},
	computed: {
		showChange() {
			return this.$route.params.hash ? true : false;
		},
	},
	methods: {
		returnInicio(): void {
			this.$router.push('/welcome');
		},
		lowerCase(): void {
			this.form.mail = this.form.mail.toLowerCase().trim();
		},
		onSubmitChange(): void {
			this.$refs['formPass'].validate(valid => {
				if (!valid) return;
				this.loadingi = true;
				this.$store
					.dispatch('changePassword', this.ruleForm)
					.then(result => {
						if (result.data.success) {
							this.$notify({
								title: result.data.title,
								message: result.data.msg,
								type: 'success',
								duration: 9000,
							});
							this.$router.push('/welcome');
						} else {
							this.$notify.error({
								title: result.data.title,
								message: result.data.msg,
								position: 'top-right',
								duration: 9000,
							});
						}
					})
					.catch(error => {
						this.$notify.error({
							title: 'Error',
							message: 'Error al cambiar la contraseña',
							position: 'top-right',
							duration: 9000,
						});
					})
					.finally(() => (this.loadingi = false));
			});
		},
		onSubmit(): void {
			this.$refs['form'].validate(valid => {
				if (!valid) return;
				this.loadingi = true;
				this.$store
					.dispatch('forgotPassword', this.form)
					.then(result => {
						if (result.data.success) {
							this.$notify({
								title: result.data.title,
								message: result.data.msg,
								type: 'success',
								duration: 9000,
							});
							this.$router.push('/welcome');
						} else {
							this.$notify.error({
								title: result.data.title,
								message: result.data.msg,
								position: 'top-right',
								duration: 9000,
							});
						}
					})
					.catch(error => {
						this.$notify.error({
							title: 'Error',
							message: 'Error en la autenticación',
							position: 'top-right',
							duration: 9000,
						});
					})
					.finally(() => (this.loadingi = false));
			});
		},
	},
	mounted() {
		this.ruleForm.hash = this.$route.params.hash;
	},
};
